import { Injectable } from '@angular/core';
import { JobService } from './job.service';
import { MarketplaceService } from './marketplace.service';
import { TopicService } from './topic.service';
import { AuthService } from './auth.service';
import { StorageTypeKey } from '../enums/StorageTypeKey';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private jobService: JobService,
    private marketplaceService: MarketplaceService,
    private topicService: TopicService,
    private authService: AuthService,
  ) {}
  async logOut() {
    try {
      const tenantId = this.authService.getTenant().id;
      if (localStorage.getItem('adminTenant')) localStorage.removeItem('adminTenant');
      if (localStorage.getItem('adminUser')) localStorage.removeItem('adminUser');
      if (localStorage.getItem('adminToken')) localStorage.removeItem('adminToken');

      await this.topicService.unsubscribeFromTopics([
        `jobs-${tenantId}`,
        `chat-${tenantId}`,
        `tenant-${tenantId}`,
        `marketplace-${tenantId}`,
        'marketplace',
      ]);
    } catch (e) {
      // ignoring error on purpose because the error thrown is that token cannot be found
    }

    window.location.href = `/v2/auth/logout`;
  }
}
